import { FC } from 'react';
import { Text } from '@connect-x-app/hybrid-ui';
import { COLORS } from '@connect-x-app/shared-ui';
import { ADMIN_TEST_IDS } from '@connect-x-app/web-test-ids';
import { Button, Icon } from '@connect-x-app/web-ui';

import './confirmationModal.scss';

type Props = {
  cancelButtonAction: () => void;
  cancelButtonLabel: string;
  confirmButtonAction: () => void;
  confirmButtonLabel: string;
  loading: boolean;
  title: string;
};

export const ConfirmationModal: FC<Props> = ({
  cancelButtonAction,
  cancelButtonLabel,
  confirmButtonAction,
  confirmButtonLabel,
  loading,
  title,
}) => {
  return (
    <div className="modal-container" data-test={ADMIN_TEST_IDS.confirmationModal.modal}>
      <Icon className="close-icon" colorName={COLORS.zulu.$08} name="closeCross" onClick={cancelButtonAction} size={2.5} />
      <div>
        <Text as="h5" color={COLORS.zulu.$06} uppercase weight="bold">
          {title}
        </Text>
        <div className="modal-buttons">
          <Button isOutline onClick={cancelButtonAction} testId={ADMIN_TEST_IDS.confirmationModal.cancel} theme="neutral">
            {cancelButtonLabel}
          </Button>
          <Button
            loading={loading}
            onClick={confirmButtonAction}
            testId={ADMIN_TEST_IDS.confirmationModal.confirm}
            theme="negative"
          >
            {confirmButtonLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};
